export const CitiesUSA = [
    "Abilene, TX",
    "Akron, OH",
    "Albuquerque, NM",
    "Alexandria, VA",
    "Allentown, PA",
    "Amarillo, TX",
    "Anaheim, CA",
    "Anchorage, AK",
    "Arlington, TX",
    "Arlington, VA",
    "Athens, GA",
    "Atlanta, GA",
    "Aurora, CO",
    "Aurora, IL",
    "Austin, TX",
    "Bakersfield, CA",
    "Baltimore, MD",
    "Baton Rouge, LA",
    "Beaumont, TX",
    "Bellevue, WA",
    "Berkeley, CA",
    "Billings, MT",
    "Birmingham, AL",
    "Boise, ID",
    "Boston, MA",
    "Boulder, CO",
    "Bridgeport, CT",
    "Brownsville, TX",
    "Buffalo, NY",
    "Cape Coral, FL",
    "Carrollton, TX",
    "Cary, NC",
    "Cedar Rapids, IA",
    "Chandler, AZ",
    "Charleston, SC",
    "Charlotte, NC",
    "Chattanooga, TN",
    "Chesapeake, VA",
    "Chicago, IL",
    "Cincinnati, OH",
    "Clarksville, TN",
    "Cleveland, OH",
    "Colorado Springs, CO",
    "Columbia, MO",
    "Columbus, GA",
    "Columbus, OH",
    "Concord, CA",
    "Corona, CA",
    "Corpus Christi, TX",
    "Costa Mesa, CA",
    "Dallas, TX",
    "Dayton, OH",
    "Denton, TX",
    "Denver, CO",
    "Des Moines, IA",
    "Detroit, MI",
    "Downey, CA",
    "Durham, NC",
    "El Monte, CA",
    "El Paso, TX",
    "Elizabeth, NJ",
    "Elk Grove, CA",
    "Escondido, CA",
    "Eugene, OR",
    "Evansville, IN",
    "Fargo, ND",
    "Fayetteville, NC",
    "Fontana, CA",
    "Fort Collins, CO",
    "Fort Lauderdale, FL",
    "Fort Wayne, IN",
    "Fort Worth, TX",
    "Fremont, CA",
    "Fresno, CA",
    "Frisco, TX",
    "Fullerton, CA",
    "Gainesville, FL",
    "Garden Grove, CA",
    "Garland, TX",
    "Gilbert, AZ",
    "Glendale, AZ",
    "Glendale, CA",
    "Grand Prairie, TX",
    "Grand Rapids, MI",
    "Greensboro, NC",
    "Hartford, CT",
    "Henderson, NV",
    "Hialeah, FL",
    "Hollywood, FL",
    "Honolulu, HI",
    "Houston, TX",
    "Huntington Beach, CA",
    "Huntsville, AL",
    "Independence, MO",
    "Indianapolis, IN",
    "Inglewood, CA",
    "Irving, TX",
    "Jackson, MS",
    "Jacksonville, FL",
    "Jersey City, NJ",
    "Joliet, IL",
    "Kansas City, KS",
    "Kansas City, MO",
    "Kent, WA",
    "Killeen, TX",
    "Knoxville, TN",
    "Lakewood, CO",
    "Lancaster, CA",
    "Laredo, TX",
    "Las Vegas, NV",
    "Lexington, KY",
    "Lincoln, NE",
    "Little Rock, AR",
    "Long Beach, CA",
    "Los Angeles, CA",
    "Louisville, KY",
    "Lubbock, TX",
    "Macon, GA",
    "Madison, WI",
    "Manchester, NH",
    "McKinney, TX",
    "Memphis, TN",
    "Mesa, AZ",
    "Mesquite, TX",
    "Miami Gardens, FL",
    "Miami, FL",
    "Milwaukee, WI",
    "Minneapolis, MN",
    "Miramar, FL",
    "Mobile, AL",
    "Modesto, CA",
    "Montgomery, AL",
    "Moreno Valley, CA",
    "Murfreesboro, TN",
    "Naperville, IL",
    "Nashville, TN",
    "New Haven, CT",
    "New Orleans, LA",
    "New York, NY",
    "Newark, NJ",
    "Newport News, VA",
    "Norfolk, VA",
    "Norman, OK",
    "Oakland, CA",
    "Oceanside, CA",
    "Oklahoma City, OK",
    "Olathe, KS",
    "Omaha, NE",
    "Ontario, CA",
    "Orange, CA",
    "Orlando, FL",
    "Overland Park, KS",
    "Oxnard, CA",
    "Palmdale, CA",
    "Pasadena, CA",
    "Pasadena, TX",
    "Paterson, NJ",
    "Pembroke Pines, FL",
    "Peoria, AZ",
    "Philadelphia, PA",
    "Phoenix, AZ",
    "Pittsburgh, PA",
    "Plano, TX",
    "Pomona, CA",
    "Port St. Lucie, FL",
    "Portland, OR",
    "Providence, RI",
    "Raleigh, NC",
    "Rancho Cucamonga, CA",
    "Reno, NV",
    "Richmond, VA",
    "Riverside, CA",
    "Rochester, NY",
    "Rockford, IL",
    "Roseville, CA",
    "Sacramento, CA",
    "Salem, OR",
    "Salinas, CA",
    "Salt Lake City, UT",
    "San Antonio, TX",
    "San Bernardino, CA",
    "San Diego, CA",
    "San Francisco, CA",
    "San Jose, CA",
    "Santa Ana, CA",
    "Santa Clara, CA",
    "Santa Clarita, CA",
    "Savannah, GA",
    "Scottsdale, AZ",
    "Seattle, WA",
    "Shreveport, LA",
    "Simi Valley, CA",
    "Sioux Falls, SD",
    "Spokane, WA",
    "Springfield, MA",
    "Springfield, MO",
    "St. Paul, MN",
    "Stamford, CT",
    "Sterling Heights, MI",
    "Stockton, CA",
    "Sunnyvale, CA",
    "Surprise, AZ",
    "Syracuse, NY",
    "Tacoma, WA",
    "Tallahassee, FL",
    "Tampa, FL",
    "Tempe, AZ",
    "Thornton, CO",
    "Thousand Oaks, CA",
    "Topeka, KS",
    "Torrance, CA",
    "Tucson, AZ",
    "Tulsa, OK",
    "Vallejo, CA",
    "Vancouver, WA",
    "Victorville, CA",
    "Virginia Beach, VA",
    "Visalia, CA",
    "Waco, TX",
    "Washington, DC",
    "West Valley City, UT",
    "Wichita, KS",
    "Winston–Salem, NC",
    "Worcester, MA",
    "Yonkers, NY"
]